module.exports = __webpack_public_path__ + "img/1.31c0f0ce.jpg";